import { Component } from '@angular/core';
import { PublicEventsService } from 'angular-auth-oidc-client';
import {AuthService} from './services/auth.service';
import {ActivatedRoute, Router} from '@angular/router';

@Component({
    selector: 'app-root',
    templateUrl: 'app.component.html',
    styleUrls  : ['./app.component.scss']
})

export class AppComponent  {
    constructor(
        private _activatedRoute: ActivatedRoute,
        private _authService: AuthService,
        private eventService: PublicEventsService,
        private _router: Router,
    ) {}
}
